import React from 'react'

import { BodyText, CTALink } from '@pb/components'

import getRoute from '../helpers/getRoute'
import styles from './RenderSubtext.scss'

const RenderSubtext = (subtext: string, subTextCta: string, trackViewAll): string | unknown => (
  <>
    {subTextCta ? (
      <CTALink
        className={styles.subtextLink}
        href={getRoute(subTextCta)}
        onClick={trackViewAll}
        Tag="a"
        inline
      >
        {subtext}
      </CTALink>
    ) : (
      <BodyText ellipsis className={styles.subtext}>
        {subtext}
      </BodyText>
    )}
  </>
)

export default RenderSubtext
